import { SolutionsCompWrapper } from "../../styles/StyledComponents/SolutionsCompWrapper";
import { offerCardMock } from "../../ui/json/offerCard.mock";
import OfferCard from "../OfferCard/OfferCard";

const SolutionsComp = () => {
  return (
    <SolutionsCompWrapper className="cmn_gap">
      <div className="container">
        <div className="solutions_heading">
          <div className="row">
            <div className="col heading_left">
              <h2>
                Solutions<span>We Offer</span>
              </h2>
            </div>
            <div className="col description_right">
              <p>
                At Webskitters Technology Solutions Pvt. Ltd, we offer
                end-to-end digital transformation with expert web design
                solutions and development services. Partner with us to access
                comprehensive solutions accelerating your business growth and
                driving long-term success.
              </p>
            </div>
          </div>
        </div>
        <div className="cardDivWrap">
          <div className="row">
            {offerCardMock?.map((data, index) => (
              <div className="card_div" key={index}>
                <OfferCard {...data} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </SolutionsCompWrapper>
  );
};

export default SolutionsComp;
